import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./style/global.css";
import "./style/components/carrusel.css";
import "./style/pages/contacto.css";
import "./style/pages/homeSelection.css";
import "./style/pages/quienesSomos.css";
import "./style/components/ServiceTopStyle.css";
import "./style/components/toggleDescription.css";
import "./style/components/menuHover.css";
import "./style/font/Archivo-VariableFont_wdth_wght.ttf";
import "./style/components/carruselClient.css";
import "./style/components/itemsService.css";
//componentes
import { Header } from "./components/layouts/Header";
import { Footer } from "./components/layouts/Footer";
import QuienSomos from "./pages/QuienSomos";
import Home from "./pages/Home";
import Contacto from "./pages/Contacto";
import Error from "./pages/Error";
import Capacitacion from "./pages/servicios/Capacitacion";
import Mantenimiento from "./pages/servicios/Mantenimiento";
import ProyectosMano from "./pages/servicios/ProyectosMano";
import ServiciosAdicionales from "./pages/servicios/ServiciosAdicionales";

function App() {
  return (
    <Router>
      <Header />
      <Switch>
        <Route exact path="/contacto" component={Contacto} />
        <Route exact path="/quien_somos" component={QuienSomos} />
        <Route path="/servicios/capacitacion" component={Capacitacion} />
        <Route path="/servicios/mantenimiento" component={Mantenimiento} />
        <Route path="/servicios/proyectomano" component={ProyectosMano} />
        <Route
          path="/servicios/serviciosadicionales"
          component={ServiciosAdicionales}
        />
        <Route exact path="/" component={Home} />
        <Route path="*" component={Error} />
      </Switch>
      <Footer />
    </Router>
  );
}

export default App;
